"use client";
import React from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SText } from "@/components/atoms";
import SHeading from "@/components/atoms/SHeading";
import FormField from "@/components/molecules/FormField";
import { phoneRegex } from "@/constants";
import { fields } from "@/constants/values";
import { FormValues } from "@/constants/types";
import { useTranslation } from "react-i18next";

const ContactForm: React.FC = () => {
    const { t } = useTranslation();

    const validationSchema = yup.object().shape({
        name: yup.string().trim().required(t("validation.required_name")),
        email: yup
            .string().trim()
            .required(t("validation.required_email"))
            .email(t("validation.invalid_email")),
        phoneNumber: yup
            .string().trim()
            .required(t("validation.required_phone"))
            .matches(phoneRegex, t("validation.invalid_phone")),
        address: yup.string().trim().optional(),
        investment: yup.string().trim().optional(),
    });

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm<FormValues>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            name: "",
            email: "",
            phoneNumber: "",
            address: "",
            investment: "",
        },
    });

    const onSubmit = () => {
        alert(t("home.contact_form.thank_you_message"));
        window.open("https://heyzine.com/flip-book/208d6a8174.html", "_blank");
        reset();
    };

    return (
        <div id="contactForm" className="w-full sm:w-3/4 mx-auto bg-white p-8">
            <div className="w-3/4 mx-auto">
                <SHeading text={t("home.contact_form.title")} tAlign="center" />
                <SText
                    className="mb-6 text-xl font-medium text-rose text-center italic"
                    text={t("home.contact_form.note")}
                />
            </div>
            <form onSubmit={handleSubmit(onSubmit)} method="POST" className="space-y-6 container mx-auto">
                {fields(t).map((field, index) => (
                    <Controller
                        key={`fields-${index}`}
                        name={field.name}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <FormField
                                {...field}
                                value={value ?? ""}
                                error={errors[field.name]?.message}
                                onChange={onChange}
                            />
                        )}
                    />
                ))}
                <div className="w-full md:w-3/4 mx-auto">
                    <button
                        type="submit"
                        className="w-full bg-primary text-white py-3 px-6 rounded-md hover:bg-lightBlue focus:outline-none"
                    >
                        {t("home.contact_form.submit_button")}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ContactForm;
